(function ($) {
    $(document).ready(function () {

        $('.js-carousel-multy-slides').each((index, carousel) => {

            const $carousel = $(carousel);
            const itemsArray = $carousel.find('.carousel-item').toArray();

            const sortItems = (Items) => {
                let activeIndex;
                Items.forEach((item, index) => {
                    if ($(item).hasClass('active')) {
                        activeIndex = index;
                        return false;
                    }
                });

                const beforeActiveItems = Items.splice(0, activeIndex);
                Items.push.apply(Items, beforeActiveItems);
                return Items;
            }

            const setIds = (Items) => {
                Items.forEach((item, index) => {

                    if (Items.length - 1 === index) {
                        item.dataset.last = true;
                    } else {
                        item.removeAttribute('data-last').removeAttribute('aria-hidden');
                    }

                    switch (index) {
                        case 0:
                            item.dataset.position = 'current';
                            break;
                        case 1:
                            item.dataset.position = 'next-1';
                            break;
                        case 2:
                            item.dataset.position = 'next-2';
                            break;
                        case 3:
                            item.dataset.position = 'next-3';
                            break;
                        case 4:
                            item.dataset.position = 'next-4';
                            break;
                        default:
                            item.removeAttribute('data-position').removeAttribute('aria-hidden');
                            break;
                    }
                });
            }

            setIds(sortItems(itemsArray));

            $carousel.on('slide.bs.carousel', function (e) {
                // before animation
                $(this).addClass(e.direction);

            });

            $carousel.on('slid.bs.carousel', function (e) {
                // after animation
                $(this).removeClass(e.direction);
                setIds(sortItems(itemsArray));
            });


        });

        //Remove Aria-hidden
        $('.carousel--featured-products').each((index, carousel) => {

            const $carousel = $(carousel);
            const itemsArray = $carousel.find('.carousel__item').toArray();

            const removeAriaHidden = (Items) => {
                Items.forEach((item, index) => {
                    item.removeAttribute('aria-hidden');
                });
            }
            // Removing aria-hidden on load
            $(window).bind('load', function () {
                removeAriaHidden(itemsArray);

            });

            // Removing aria-hidden on change
            $carousel.on('settle.flickity', function (event, index) {
                removeAriaHidden(itemsArray);
            });
        });

        //set Tabindex
        $('.carousel--homepage-hero').each((index, carousel) => {

            const $carousel = $(carousel);
            const itemsArray = $carousel.find('.carousel__item').toArray();

            const setTabindex = (Items) => {
                Items.forEach((item, index) => {
                    $(item).find("a").each(function () {
                        $(this).attr('tabindex', ($(item).hasClass("is-selected") ? '0' : '-1'));
                    });
                });
            }
            // set Tabindex on load
            $(window).bind('load', function () {
                setTabindex(itemsArray);

            });

            // set Tabindex on change
            $carousel.on('settle.flickity', function (event, index) {
                setTabindex(itemsArray);
            });
        });

        $('.carousel--homepage-hero ol.flickity-page-dots li').each((index, element) => {
            $(element).attr('tabindex', 0);
        });

        $('.carousel--homepage-hero ol.flickity-page-dots li.dot').keypress(function (event) {
            var key = event.which;
            if (key == 13 || key == 32) {
                $(this).trigger('click');
                event.preventDefault();
            }
        }
        );

        if ($('.js-carousel-login-link').length) {
            updateCarouselLoginLinks();
            $(window).on('locationchange', updateCarouselLoginLinks);
        }

    });

    const updateCarouselLoginLinks = function () {
        $('.js-carousel-login-link').each((i, e) => {
            const baseLoginUrl = $(e).data('loginbaseurl');

            let returnUrl = new URL(window.location);
            returnUrl.searchParams.set('atc_code', $(e).closest('.add-to-cart-wrapper').data('code'));
            returnUrl.searchParams.set('atc_qty', $(e).closest('.quantity-wrapper').find('input').val());
            const recId = $(e).closest('.recommendation-wrapper').data('recommendation-id') || null;
            if (!!recId) returnUrl.searchParams.set('atc_recid', recId);
            $(e).attr('href', baseLoginUrl + "?ReturnUrl=" + encodeURIComponent(returnUrl.pathname + returnUrl.search));
        });
    }
})($);